import { useAuthStore } from '~/stores/useAuthStore'

const saving = ref(false)
const recovering = ref(false)
const lastSavedAt = ref<number | null>(null)
const lastError = ref<string | null>(null)
const daycareSyncing = ref(false)

let saveCount = 0

export function trackSaveStart() {
  saveCount++
  saving.value = true
  lastError.value = null
}

export function trackSaveEnd(err?: unknown) {
  saveCount = Math.max(0, saveCount - 1)
  if (saveCount === 0) saving.value = false
  if (err) {
    lastError.value = err instanceof Error ? err.message : String(err)
  } else {
    lastSavedAt.value = Date.now()
    lastError.value = null
  }
}

export function clearSaveSyncError() {
  lastError.value = null
}

export function setSaveRecoverySyncing(active: boolean) {
  recovering.value = active
}

export function setDaycareSyncing(active: boolean) {
  daycareSyncing.value = active
}

export function markDaycareSyncSuccess() {
  lastSavedAt.value = Date.now()
  lastError.value = null
}

export function markDaycareSyncError(message: string) {
  lastError.value = message
}

export function useGameSyncStatus() {
  const auth = useAuthStore()

  const status = computed<'idle' | 'syncing' | 'ok' | 'error' | 'recovering'>(() => {
    if (!auth.isAuthenticated) return 'idle'
    if (recovering.value) return 'recovering'
    if (saving.value || daycareSyncing.value || auth.gameLoading) return 'syncing'
    if (lastError.value) return 'error'
    if (lastSavedAt.value) return 'ok'
    return 'idle'
  })

  const labelFr = computed(() => {
    switch (status.value) {
      case 'syncing':
        return 'Synchronisation…'
      case 'recovering':
        return 'Récupération…'
      case 'error':
        return 'Erreur de sauvegarde'
      case 'ok':
        return 'Sauvegardé'
      default:
        return ''
    }
  })

  const labelEn = computed(() => {
    switch (status.value) {
      case 'syncing':
        return 'Syncing…'
      case 'recovering':
        return 'Recovering…'
      case 'error':
        return 'Save error'
      case 'ok':
        return 'Saved'
      default:
        return ''
    }
  })

  return { status, labelFr, labelEn, lastError }
}
